import type { FaireReviewEntity } from "../../entity_types/review";

// Real review for Lemonade Shoes, read off their public Faire reviews list
// (Ryan, 2026-08-17). The only one of the four with purchased products
// attached, which is what makes it the useful case for the spotlight module's
// thumbnails.
//
// INCOMPLETE ON PURPOSE: Faire shows three purchased products against this
// review. Only the floral sneaker is identifiable with confidence from the
// catalog — Lemonade's product photography groups several colourways into one
// shot, so the pink heel and the pom-toe sandal can't be matched to a token by
// eye without guessing. Rather than attach two plausible-but-wrong products to
// a real retailer's order, this carries the one that's certain. Add the other
// two tokens when we have them.
export const review_ls8: FaireReviewEntity = {
  token: "review_ls8",
  type: "review",
  brandName: "Lemonade Shoes",
  brandToken: "b_mz3xxxsvnf",
  reviewType: "brand",
  reviewerName: "Stacylynn",
  reviewerLocation: "Dauphin, PA",
  stars: 5,
  reviewText: "Love love love",
  reviewDate: "Apr 3, 2026",
  purchasedProductTokens: ["p_84x66qe9z6"],
  meta: {
    source: "api",
    importedAt: "2026-08-17T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
